/**
 * Token model for Firestore tokens collection
 * Used for payment validation and other system tokens
 */

export interface Token {
  id: string; // 20-digit alphanumeric token
  type: 'payment' | 'sales' | 'admin' | 'temporary';
  status: 'active' | 'used' | 'expired' | 'revoked';
  createdAt: Date;
  createdBy: string; // Admin user ID who created the token
  expiresAt?: Date; // Optional expiration date
  usageLimit?: number; // Optional usage limit (null = unlimited)
  usageCount: number; // Current usage count
  usedAt?: Date; // When token was first used
  usedBy?: string; // User ID who used the token
  metadata?: {
    restaurantId?: string;
    userId?: string;
    notes?: string;
    [key: string]: any;
  };
}

export interface TokenValidationResult {
  isValid: boolean;
  token?: Token;
  error?: string;
}

/**
 * Generate a 20-digit alphanumeric token (A-z, 0-9)
 */
export const generateToken = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 20; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

/**
 * Validate token format (20 alphanumeric characters)
 */
export const isValidTokenFormat = (token: string): boolean => {
  const tokenRegex = /^[A-Za-z0-9]{20}$/;
  return tokenRegex.test(token);
};
